<i *ngIf="icon" class="material-icons-outlined cmr-4">{{ icon }}</i>
<ng-content></ng-content>
